import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
let initialstate = {
  isLoading: false,
  pageSurgeons: [],
  pagination: {},
  sorter: {},
  searchText: '',
  selectedSurgeons: [],
  surgeon: {},
}
export default function surgeon_operation(state = { ...initialstate }, action) {
  switch (action.type) {
    case ActionType.OPERATION_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.SURGEON_LIST:
      return {
        ...state,
        isLoading: action.isLoading,
        surgeons: action.surgeons,
      }
    case ActionType.SURGEONS:
      return {
        ...state,
        isLoading: action.isLoading,
        pageSurgeons: action.pageSurgeons,
        pagination: action.pagination,
        sorter: action.sorter,
        searchText: action.searchText,
      }
    case ActionType.SURGEON_SELECT:
      return { ...state, selectedSurgeons: action.selectedSurgeons }
    case ActionType.SURGEON_ERROR:
      return { error: action.hasError, message: action.message }
    case ActionType.SET_SURGEON:
      return { ...state, surgeon: action.surgeon }
    case ActionType.LOGIN_AS_COMPANY:
      return {
        ...state,
        isLoading: false,
        pageSurgeons: [],
        pagination: {},
        sorter: {},
        searchText: '',
        selectedSurgeons: [],
        surgeon: {},
      }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
